import { Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { isTauri } from '@tauri-apps/api/core';
import { AddressFetcher } from 'cloak-auth/src/Client/AddressFetcher';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SWRConfig } from 'swr';

import { TauriContainer } from '@ui/Components/Device/TauriContainer';

import DeviceDiscoveryManager from 'kerberus-components/src/Components/DeviceDiscovery/DeviceDiscoveryManager';
import { useCameraStore } from 'kerberus-components/src/Components/Scan/QR/cameraStore.ts';

import TopNavigationBar from './Components/Layout/Appbar.tsx';
import MainContainer from './Components/Layout/MainContainer';
import theme from './Theme';

const navBarHeight = '60px';

export default function App() {
    const { cameraOpen } = useCameraStore();
    const tauri = isTauri();

    return (
        <SWRConfig
            value={{
                dedupingInterval: 10_000,
                fetcher: AddressFetcher,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
            }}
        >
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {!cameraOpen && <CssBaseline />}
                    {tauri ? <TauriContainer /> : <DeviceDiscoveryManager autoPrompt />}
                    <Suspense fallback={null}>
                        <Box
                            sx={{
                                bgcolor: '#edf2f6',
                                paddingBottom: 'var(--safe-area-inset-bottom, 0px)',
                                paddingLeft: 'var(--safe-area-inset-left, 0px)',
                                paddingRight: 'var(--safe-area-inset-right, 0px)',
                                paddingTop: 'var(--safe-area-inset-top, 0px)',
                            }}
                        >
                            <TopNavigationBar navBarHeight={navBarHeight} />
                            <MainContainer navBarHeight={navBarHeight}>
                                <Outlet />
                            </MainContainer>
                        </Box>
                    </Suspense>
                </LocalizationProvider>
            </ThemeProvider>
        </SWRConfig>
    );
}
